var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18.797,
    viewBox: "0 0 18 18.797",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1217",
    "data-name": "Rectangle 1217",
    width: 18,
    height: 18.797,
    fill: "#2744a2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4953",
    "data-name": "Group 4953",
    transform: "translate(-320 -1212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4941",
    "data-name": "Group 4941",
    transform: "translate(320 1212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2229",
    "data-name": "Group 2229",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5517",
    "data-name": "Path 5517",
    d: "M15.435,13.337l.011.01c.024.023.048.045.075.067l.013.01c.022.017.044.034.068.05l.031.02.057.034.007,0,.026.014c.027.014.055.027.084.039l.017.007c.026.01.051.019.078.027l.014,0c.03.009.061.016.088.022l.022.005.062.009.016,0,.033,0h.022c.029,0,.058,0,.088,0H16.3l.053,0,.027,0c.029,0,.057-.007.082-.012l.016,0a1.148,1.148,0,0,0,.492-.234,1.128,1.128,0,0,0,.086-.078l6.18-6.18a1.149,1.149,0,0,0-1.625-1.625L17.4,9.751V1.174A1.171,1.171,0,0,0,16.286,0,1.149,1.149,0,0,0,15.1,1.149v8.6L11.255,5.908A1.149,1.149,0,0,0,9.63,7.533Z",
    transform: "translate(-7.435 0)",
    fill: "#2744a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5518",
    "data-name": "Path 5518",
    d: "M16.687,80.8H1.315a1.317,1.317,0,0,0,0,2.633H16.687a1.317,1.317,0,0,0,0-2.633",
    transform: "translate(-0.001 -64.634)",
    fill: "#2744a2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.8d2ca657cad42d91dcd8ef003ea674ae.svg";
export { ForwardRef as ReactComponent };